var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXmarkSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 512,
    viewBox: "0 0 320 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.6 150.6C323.1 138.1 323.1 117.8 310.6 105.3C298.1 92.8 277.8 92.8 265.3 105.3L160 210.7L54.5998 105.4C42.0998 92.9 21.7998 92.9 9.2998 105.4C-3.2002 117.9 -3.2002 138.2 9.2998 150.7L114.7 256L9.3998 361.4C-3.1002 373.9 -3.1002 394.2 9.3998 406.7C21.8998 419.2 42.1998 419.2 54.6998 406.7L160 301.3L265.4 406.6C277.9 419.1 298.2 419.1 310.7 406.6C323.2 394.1 323.2 373.8 310.7 361.3L205.3 256L310.6 150.6Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmarkSolid);
export default __webpack_public_path__ + "static/media/xmark-solid.fd67885656803069a432cc80361d558c.svg";
export { ForwardRef as ReactComponent };